// extracted by mini-css-extract-plugin
module.exports = {"id-card-container":"SharedProfileData_id-card-container__8f_8x","id-card-image":"SharedProfileData_id-card-image__1gbpv"};